
import { Button, Chip, Heading, Modal } from "cai-fusion";
import { useContext, useRef, useState } from "react";
// Note - not Symphony's SettingsContext.
import { SettingsContext } from "../../../../../contexts/SettingsContext";

const AddUserModal = ({ isHidden, onClose, availableLicenses }) => {
	const [usersToLicense, setUsersToLicense] = useState([]);
	const [searchValue, setSearchValue] = useState("");
	const searchTimeoutRef = useRef();
	const [users, setUsers] = useState([]);
    
	const { searchUsers, provisionLicenseToMany } = useContext(SettingsContext);

	const addUserToLicense = (user) => {
		if (usersToLicense.includes((x) => x.identifier === user.identifier)) {
			return;
		}

		const newUsersToLicense = [...usersToLicense];
		newUsersToLicense.push(user);
		setUsersToLicense(newUsersToLicense);
	};

	const handleSave = () => {
		provisionLicenseToMany(usersToLicense.map((u) => u.identifier));
	};

	const handleInputChange = (e) => {
		const currentValue = e.target.value;
		setSearchValue(e.target.value);
		if (e.target.value === "" || e.target.value === undefined) {
			setUsers([]);
            return;
		}

        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }

        // Set a new timeout
        searchTimeoutRef.current = setTimeout(() => {
            // Use currentValue directly
            searchUsers(currentValue).then((resp) => {
                const newUsers = resp.filter((user) => {
                    // Filter out all users that are already licensed or are set to be licensed
                    return user.licenseStatus !== 0 && !usersToLicense.some((u) => u.identifier === user.identifier);
                });
                setUsers(newUsers);
            });
        }, 300);
	};

	return (
		<Modal
			isHidden={isHidden}
			onClose={onClose}
			className="o-modal--no-scroll"
			title="Add New Users"
			actions={
				<>
                    <Button 
                        outline
                        children="Cancel"
                        onClick={(e) => {
                            e.preventDefault();
                            onClose();
                        }}
                    />
                    <Button 
                        children="Add Users"
                        onClick={(e) => {
                            e.preventDefault();
                            handleSave();
                            onClose();
                        }}
                    />
				</>
			}
		>
			<div className="l-row">
				<div className="l-one-col">
					<p className="a-muted-text">Type below to search for users which you can provision a license to.</p>
					<form action="" className="o-form">
						<div className="m-autocomplete-input">
							<label
								className="visually-hidden"
								htmlFor="autocompleteInput"
							></label>
							<input
                                disabled={availableLicenses - usersToLicense.length <= 0}
								value={searchValue}
								className='a-search-input__text-box'
								type="text"
								placeholder={availableLicenses - usersToLicense.length <= 0
                                    ? "You have no more licenses to allocate."
                                    : "Search users..."
                                }
								aria-label="Search"
								id="search_field"
								name="search_field"
								onChange={(e) => {
									e.preventDefault();
									if (availableLicenses - usersToLicense.length <= 0) {
                                        return;
                                    }
									handleInputChange(e);
								}}
							/>
							<div
								className="m-autocomplete-input__dropdown m-autocomplete-input__dropdown--shown"
								id="autocompleteDropdown"
							>
								{searchValue !== "" && (
									users?.map((user) => {
										return (
											<button
												className="m-autocomplete-input__dropdown-item"
												type="button"
												onClick={(e) => {
													e.preventDefault();
													setSearchValue("");
													setUsers([]);
													addUserToLicense(user);
												}}
											>
												<div className="m-autocomplete-input__dropdown-item-title">
													{user?.givenName ?? user?.identifier} {user?.familyName ?? ""} {user?.licenseStatus === 0 ? "(Licensed)" : ""}
												</div>
												<div className="m-autocomplete-input__dropdown-item-meta">
													{user.jobTitle ?? user?.identifier}
												</div>
											</button>
										);
									})
								)}
							</div>
						</div>
					</form>
                    <p className={`${(availableLicenses - usersToLicense.length > 0) ? "a-bold-text" : "a-warning-text"}`}>
                        Remaining Licenses: {Math.max(availableLicenses - usersToLicense.length, 0)}
                    </p>
                    <Heading size={4} className="l-mt-xs">
                        Users to Add
                    </Heading>
					{usersToLicense.length === 0 ?
                        <p className="a-muted-text">There are currently no users selected to license.</p> :
                        <ul className="m-chip-group">
                            <li className="m-chip-group__chip">
                                {usersToLicense.map((user) => {
                                    return (
                                        <Chip 
                                            chipText={`${user?.familyName ?? user?.identifier}, ${user?.givenName ?? ""}`}
                                            key={user?.identifier}
                                            onClose={(e) => {
                                                e.preventDefault();
                                                // Remove the user from the list of added users.
                                                setUsersToLicense(usersToLicense.filter((u) => u.identifier !== user.identifier));
                                            }}
                                        />
                                    );
                                })}
                            </li>
                        </ul>
                    }
				</div>
			</div>
		</Modal>
	);
};


export default AddUserModal;